import React, { useState, useRef, useEffect } from "react";
import { sortOptions } from "../../utils/constants";

function SortByDropdown({selectedSortOption, setSelectedSortOption}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(selectedSortOption);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedSortOption(option)
    setSelectedItem(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative bg-[#1A1A1A] rounded-[10px] px-[20px] py-[8px] text-[14px] lg:text-sm leading-4 font-normal h-full"
      ref={dropdownRef}
    >
      <div className="flex items-center w-full gap-[22px]">
        <div className="text-white/50 py-[6px] whitespace-nowrap">Sort By</div>
        <div
        id="sortUi"
          className="text-white cursor-pointer flex items-center gap-[10px] justify-between w-full capitalize"
          onClick={handleToggle}
        >
          {selectedItem}
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
            >
              <path
                d="M11 1L6 5L1 1"
                stroke="#FFF5F5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>

      {isOpen && (
        <div className="absolute top-12 left-0 w-full h-auto p-3 rounded-[10px] border-[1px] border-white/[.04] bg-[#1A1A1A] z-30">
          <ul
            className="flex flex-col"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            {/* {sortOptions.map((option, index) => (
              <li
                key={index}
                onClick={() => handleOptionClick(option)}
                className="text-sm leading-4 font-normal cursor-pointer"
              >
                {option}
              </li>
            ))} */}
            {Object.entries(sortOptions).map(([key, value]) => (
              <li
                key={key}
                onClick={() => handleOptionClick(key)}
                className={`text-sm leading-4 font-normal cursor-pointer capitalize py-2 px-[6px] mb-1 rounded-lg hover:bg-white/10 ${selectedSortOption?.toLowerCase() === key ? "bg-white/10" : ""}`}
              >
                {key}
              </li>
          ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default SortByDropdown;
